An array of suggested locations for the text provided in decreasing order of relevance.

While a maximum of 20 locations can be requested, the current implementation does not return more than 10 recommendations.

This query accepts browser tokens that include the `query:ontologies` or `query:enhanced-job-posting` scope.
